import { useState } from 'react';
import { useSelector } from 'react-redux';
import BotHaloAnimation from 'src/components/BotHaloAnimation/BotHaloAnimation';
import FactCheckScopeNotice from 'src/components/FactCheckScopeNotice/FactCheckScopeNotice';
import { useClientConfig } from 'src/hooks/useClientConfig';
import ibercheck from 'src/static/images/home/ibercheck-ue.png';
import { Message } from 'src/types';
import NewChatButton from '../Chat/NewChatButton/NewChatButton';
import VerificationText from '../VerificationText/VerificationText';
import WidgetLogo from '../Widget/WidgetLogo/WidgetLogo';
import WidgetText from '../Widget/WidgetText/WidgetText';

import './AsideNewChat.sass';

const AsideNewChat = ({ handleClose }: { handleClose: () => void }) => {
	const noMessages = useSelector((s: { messages: Message[] }) => !s?.messages?.length);
	const client = useClientConfig();

	const [play, setPlay] = useState(false);
	const isIberCheckClient = client?.name?.toLocaleLowerCase()?.includes('ibercheck');
	const iberCheckSrc = `${window?._env_?.HOST_URL ?? ''}${ibercheck}`;

	return (
		<div id="aside-new-chat">
			<header onMouseEnter={() => setPlay(true)} onMouseLeave={() => setPlay(false)}>
				{client && client?.image ? (
					<WidgetLogo />
				) : (
					<a className="logo" target="_blank" href={client?.canonicalUrl?.toString() ?? 'https://trueflag.ai'} rel="noreferrer">
						<BotHaloAnimation play={play} />
					</a>
				)}
			</header>
			<section className="center">
				{client && client?.text ? <WidgetText /> : <VerificationText />}
				<NewChatButton disabled={noMessages} callback={handleClose} />
			</section>
			{isIberCheckClient && (
				<a href={'https://ibercheck.network'} target="_blank" rel="noreferrer">
					<img className="ibercheck-background" src={iberCheckSrc} alt="ibercheck" />
				</a>
			)}
			<FactCheckScopeNotice />
		</div>
	);
};

export default AsideNewChat;
